import React, { memo } from 'react';
import { View } from 'react-native';
import { createUseStyle } from '@redlink/assets/styles';
import { Text, Space } from '@redlink/components/atoms';

export const ChartColorGuid = memo(({ data = [], style }) => {
  const { styles } = useStyle();

  return (
    <View style={[styles.container, style]}>
      {data.map(({ color, title }) => {
        return (
          <>
            <View style={styles.itemContainer}>
              <Text style={styles.itemText}>{title}</Text>
              <Space size={8} />
              <View
                style={[styles.colorContainer, { backgroundColor: color }]}
              />
            </View>
            <Space />
          </>
        );
      })}
    </View>
  );
});

const useStyle = createUseStyle(({ colors, size, shadow }) => ({
  container: {
    flexDirection: 'row-reverse',
    alignItems: 'center',
  },
  itemContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: colors.gray7,
    paddingStart: 5,
    borderRadius: 5,
  },
  itemText: {
    color: colors.black,
    fontSize: 14,
  },
  colorContainer: {
    width: 24,
    height: 24,
    borderRadius: 5,
  },
}));
